import React, { Component } from 'react';
import Alert from '../common/Alert';

import api from '../../config/api';
import SecuriForumForm from "../form/SecuriForumForm";
import image from '../../media/prizegame.jpg';

class SecuriForumPage extends Component{

	constructor(){
		super();
		this.state={
			name: '',
			email: '',
			phone: '',
			alertMessage: '',
			alertType: '',
			alertRendered:false
		};
	}

	setButtonDisabled = (disabled) => {
		this.setState({setButtonDisabled: disabled});
	};

	setForm = (name, value) => {
		this.setState({
			[name]:value
		});
	};

	sendForm = () => {

		if(this.state.name.length <= 0 ||
			this.state.email.length <= 0 ||
			this.state.phone.length <= 0 ){
			this.setState({
				alertMessage: "A név, a telefonszám és az email kötelező mezők!",
				alertType: "FAIL",
				alertRendered: true
			});
			return;
		}

		const options = {
			method: 'POST',
			body: JSON.stringify({
				name: this.state.name,
				email: this.state.email,
				phone: this.state.phone,
				question3: this.state.question3,
				question3Add: this.state.question3Add,
				question4: this.state.question4,
				question4Add: this.state.question4Add,
				question5: this.state.question5,
				question5Add: this.state.question5Add,
				question6: this.state.question6,
				question7: this.state.question7
			}),
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		};

		fetch(api.prizegame, options)
			.then(res => res.json())
			.then(data => this.setState({
				alertMessage: data.text,
				alertType: data.status,
				alertRendered: true
			}))
			.catch(err => console.log(err));
	};

	render(){
		return (
			<div className="container-flex">
				<h2 className="page__title page__title--securiforum">Ajándékutalvány Önnek</h2>
				<div className="page page--securiforum">
					<div className="securiforum__prizegame">
						<div className="securiforum__prizegame-info">
							<h3>Köszönjük, hogy meglátogat minket a SecuriForum kiállításon az „I” jelű kiállítói helyen <br />
								(2017. október 5-6., Lurdy Ház).</h3>
							<p>Kérem, válaszoljon néhány egyszerű kérdésre és <strong  className="color-green">mi -30% kedvezményt adunk első vásárlásából.</strong></p>
							<p>Az ajándékutalványt a résztvevőknek emailben juttatjuk el a kiállítás után.</p>
						<SecuriForumForm
							buttonDisabled={this.state.buttonDisabled}
							setForm={this.setForm}
							sendForm={this.sendForm}
						/>
						<Alert
							alertType={this.state.alertType}
							alertMessage={this.state.alertMessage}
							rendered={this.state.alertRendered}/>
						</div>
						<div className="securiforum__prizegame-image">
							<img src={image} alt="AMIKO HOME NYEREMÉNYJÁTÉK" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SecuriForumPage;


// WEBPACK FOOTER //
// ./src/components/page/SecuriForumPage.js